import React from 'react';
import styles from './SystemDetails.module.css';
import { useSelector } from 'react-redux';
import ModuleCellGraphCard from './ModuleCellGraphCard';
import LastReadingBartChart from './LastReadingBartChart';
import { DataGrid } from '@material-ui/data-grid';
import { useTranslation } from 'react-i18next';

function ModulesScreen({ systemId }) {
  const modules = useSelector(
    (state) => state.bessReducer.details[systemId].cabinets[0].modules
  );
  const { t } = useTranslation();

  const columns = [
    { field: 'serialNumber', headerName: t('serialNumber'), width: 170 },
    { field: 'id', headerName: t('moduleId'), width: 300 }
  ];
  const barHeight = '25vh';

  return (
    <div className={styles.modulesScreenContainer}>
      <div className={styles.modulesListCard}>
        <DataGrid columns={columns} rows={modules} />
      </div>
      <div className={styles.modulesAnalyticsContainer}>
        <LastReadingBartChart systemId={systemId} barHeight={barHeight} />
        <ModuleCellGraphCard systemId={systemId} barHeight={barHeight} />
      </div>
    </div>
  );
}

export default ModulesScreen;
